import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Item from "./Item";
import { TodoContext } from "./context/todoContext/todoState";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

function Content() {
  const todoContext = useContext(TodoContext);
  const { todos } = todoContext;
  const classes = useStyles();
  return (
    <List>
      {todos.map((todo) => (
        <Item todo={todo} key={todo.id}></Item>
      ))}
    </List>
  );
}

export default Content;
